import './DashboardSectionHeader.css';

/**
 * Cabeçalho reutilizável para seções analíticas e operacionais dos dashboards.
 * A ação é opcional para permitir filtros, indicadores ou botões no lado direito.
 */
const DashboardSectionHeader = ({ icon, accentClass = '', eyebrow, title, subtitle, action }) => (
    <div className="dashboard-section-header">
        <div className="dashboard-section-header__identity">
            {icon && (
                <div className={`dashboard-section-header__icon ${accentClass}`.trim()}>
                    <i className={`fa-solid ${icon}`} />
                </div>
            )}
            <div>
                {eyebrow && <p className="dashboard-section-header__eyebrow">{eyebrow}</p>}
                <h5 className="dashboard-section-header__title">{title}</h5>
                {subtitle && <p className="dashboard-section-header__subtitle">{subtitle}</p>}
            </div>
        </div>
        {action && <div className="dashboard-section-header__action">{action}</div>}
    </div>
);

export default DashboardSectionHeader;
